import { familyResources } from 'utils/productMaps'
export const familyDomain = familyResources.name
